import { Provider } from '@angular/core';

import { ScheduleUseCasesImpl } from '@app/domain/use-cases/mot/schedule/schedule.use-cases';
import { SCHEDULE_USE_CASES } from '@app/domain/use-cases/mot/schedule/schedule.use-cases.contract';

export const scheduleUseCasesProvider: Provider = {
  provide: SCHEDULE_USE_CASES,
  useClass: ScheduleUseCasesImpl
};
